let proximoId = 0;

function campoDe(el) {
  return el.querySelector('input:not([type="hidden"]), textarea');
}

function aplicar(el, vm) {
  const campo = campoDe(el);
  if (!campo) return;

  const mensagem = vm.validationState === "error" ? vm.validationTarget.find(Boolean) || "" : "";
  el._erroAcessivel.textContent = mensagem;

  const descricoes = String(vm.$attrs["aria-describedby"] || "").split(" ").filter(Boolean);
  if (mensagem) descricoes.push(el._erroAcessivel.id);

  if (descricoes.length) campo.setAttribute("aria-describedby", descricoes.join(" "));
  else campo.removeAttribute("aria-describedby");

  if (mensagem) campo.setAttribute("aria-invalid", "true");
  else campo.removeAttribute("aria-invalid");
}

export default {
  inserted(el, _, vnode) {
    const vm = vnode.componentInstance;
    if (!vm) return;

    const mensagem = document.createElement("span");
    mensagem.id = `erro-campo-${++proximoId}`;
    mensagem.hidden = true;
    el.appendChild(mensagem);
    el._erroAcessivel = mensagem;

    el._pararErroAcessivel = vm.$watch(
      () => [vm.validationState, vm.validationTarget, vm.$attrs["aria-describedby"]],
      () => aplicar(el, vm),
      { immediate: true }
    );
  },
  unbind(el) {
    if (el._pararErroAcessivel) el._pararErroAcessivel();
  },
};

export function focarPrimeiroErro(form) {
  const invalido = form.inputs.find((input) => input.validationState === "error");
  const campo = invalido && campoDe(invalido.$el);
  if (campo) form.$nextTick(() => campo.focus());
}
